var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 4.65789L3.56266 15.7623C3.58992 16.1773 3.93451 16.5 4.35043 16.5H10.6496C11.0655 16.5 11.4101 16.1773 11.4373 15.7623L12.1667 4.65789M2.83333 4.65789H0.5M2.83333 4.65789H4.38889M12.1667 4.65789H14.5M12.1667 4.65789H10.6111M4.38889 4.65789V3.07895C4.38889 2.20692 5.09581 1.5 5.96784 1.5H9.03217C9.90419 1.5 10.6111 2.20692 10.6111 3.07895V4.65789M4.38889 4.65789H10.6111",
    stroke: "white",
    strokeWidth: 1.57895
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDelete);
export default __webpack_public_path__ + "static/media/whiteDelete.b62a1904da123137eaf0b57f42856889.svg";
export { ForwardRef as ReactComponent };